import { createStore } from 'vuex'
// import variables from '@/assets/variable.scss';

export default createStore({
  state: {
    isMobile: false, // 添加的移动端标识变量
    windowWidth: 0   // 之前已存在的窗口宽度变量
  },
  getters: {
    isMobile: state => state.isMobile,
    windowWidth: state => state.windowWidth
  },
  mutations: {
    SET_IS_MOBILE(state, isMobile) {
      state.isMobile = isMobile
    },
    SET_WINDOW_WIDTH(state, width) {
      state.windowWidth = width
      // 通常在设置窗口宽度时也更新是否为移动端
      state.isMobile = width < 768 // 可根据实际需求调整断点
    }
  },
  actions: {
    updateWindowWidth({ commit }, width) {
      commit('SET_WINDOW_WIDTH', width)
    }
  },
  modules: {
  }
})